// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inline[data-v-4f825d88]{margin-left:5px}.tips[data-v-4f825d88]{padding-left:20px}.name[data-v-4f825d88]{margin-bottom:10px}", ""]);
// Exports
module.exports = exports;
